import React, { useEffect } from 'react';

import {
    InputLabel,
    Box,
    Button,
    Modal,
} from '@mui/material';
import CropIcon from '@mui/icons-material/Crop';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import BlurOffIcon from '@mui/icons-material/BlurOff';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import RefreshIcon from '@mui/icons-material/Refresh';
import { storage } from '../../../utility/firebase';
import { uploadBytes, ref } from 'firebase/storage';
import { useUtilityContext } from '../../../utility-provider';
import ConfirmDialog from '../../components/ConfirmDialog';
import { LOCAL_CONSTANT } from '../../Const'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    setPictureEditMode,
    setPictureReload,
    setPictureCropRect,
    setPictureOriginCropRect,
} from "../../../features/pictureEditSlice";

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "90%",
    height: "96%",
    backgroundColor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
};

const TOUCHRESET = 0
const TOUCHSTART = 1
const TOUCHEND = 2

const CROP_WIDTH = 8
const CROP_HIEGHT = 6

interface PhotoEditProps {
    props: {
        open: boolean,
        handleModal: React.Dispatch<React.SetStateAction<boolean>>,
        editImgSrc: string,
        editImgMeta: any,
        editFlg: boolean,
        setEditFlg: React.Dispatch<React.SetStateAction<boolean>>,
        setEditImgSrc: React.Dispatch<React.SetStateAction<string>>,
        rowData: any,
        openId: number,
        changeEditPhoto: any,
    }
};

const PhotoEdit: React.FC<PhotoEditProps> = ({ props }) => {
    //各種設定値定数
    const defaultLineWidth: number = 2; // デフォルトの線の太さ
    const thickLineWidth: number = 6; // BOLDモード時の線の太さ
    const defaultEraserWidth: number = 24; // デフォルトの消しゴムの太さ
    const thickEraserWidth: number = 48; // BOLDモード時の線の太さ
    const defaultLineColor: string = "black"; // デフォルトの線の色
    const defaultTransParency: number = 1; // デフォルトの線の透過度
    const halfTransParency: number = 0.3; // ぼかし時の線の透過度
    const cropHandleLength: number = 12; // トリミング用ドラッグポイント辺長
    const cropHandleRangeMagnification: number = 2; // トリミング用ドラッグポイント範囲倍率
    interface Point {
        x: number;
        y: number;
    };
    const selectedList = {
        borderLeft: "4px solid #3ccc0094",
    };
    const nonSelectedList = {};
    const lineColorKinds: any = {
        // 線の色設定
        black: "black",
        red: "red",
        orange: "orange",
        blue: "blue",
        green: "green",
    };
    const dispatch = useAppDispatch();

    // モーダルopen
    const [open, setOpen] = React.useState(false);

    const objPictureEdit = useAppSelector((state) => state.pictureEdit);
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    const utilityCtx = useUtilityContext();

    // 画像サイズ
    const [imageSize, setImageSize] = React.useState({ width: 0, height: 0 })
    // 画像用
    const canvasRef = React.useRef<HTMLCanvasElement>(null);
    // 直線ポイント描画用
    const straightLinePointCanvasRef = React.useRef<HTMLCanvasElement>(null);
    // 描画用
    const lineCanvasRef = React.useRef<HTMLCanvasElement>(null);
    // マージ用
    const mergeCanvasRef = React.useRef<HTMLCanvasElement>(null);
    // トリミング範囲用
    const cropCanvasRef = React.useRef<HTMLCanvasElement>(null);
    // トリミング用
    const trimingCanvasRef = React.useRef<HTMLCanvasElement>(null);

    //画像用canvasのcontext
    const [canvasContext, setCanvasContext] =
        React.useState<CanvasRenderingContext2D | null>(null);
    // 描画用canvasのcontext
    const [lineCanvasContext, setLineCanvasContext] =
        React.useState<CanvasRenderingContext2D | null>(null);
    // 直線始点ポイント描画用
    const [straightLinePointCanvasContext, setStraightLinePointCanvasContext] =
        React.useState<CanvasRenderingContext2D | null>(null);
    //切取り用canvasのcontext
    const [cropCanvasContext, setCropCanvasContext] =
        React.useState<CanvasRenderingContext2D | null>(null);
    // マージ用canvasのcontext
    const [mergeCanvasContext, setMergeCanvasContext] =
        React.useState<CanvasRenderingContext2D | null>(null);
    // トリミング用canvasのcontext
    const [trimingCanvasContext, setTrimingCanvasContext] =
        React.useState<CanvasRenderingContext2D | null>(null);

    /**
     * 編集用変数
     */
    // クリック開始点
    const [startToutchPoint, setStartToutchPoint] = React.useState<Point>({ x: 0, y: 0 });
    // 
    const [touchStart, setTouchStart] = React.useState(0)
    // マウスのドラッグ判定用
    const [drawing, setDrawing] = React.useState(false);
    // 文字
    const [textValue, setTextValue] = React.useState("");
    /**
     * 編集用変数
     */
    const [titleValue, setTitleValue] = React.useState("")
    // ダイアログ
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (props.open) {
            if (props.rowData.id === props.openId) {
                setTitleValue(props.rowData.id + '：' + props.rowData.title + ' 写真編集')
                setOpen(true);
            } else {
                setTitleValue("")
                setOpen(false);
            }
        }
    }, [props.open])

    //キャンセルボタン押下時のイベント
    const closeEditForm = () => {
        setOpen(false);
        dispatch(setPictureEditMode("lineMode"));
        props.setEditFlg(false);
        props.setEditImgSrc("");
        props.handleModal(false)
    }

    // 画像変更時。canvasへの画像表示、各種設定初期化。
    useEffect(() => {
        refreshCanvas(720, 540);
    }, [props.editImgSrc]);


    const refreshCanvas = (maxWidth: number, maxHeight: number): void => {
        const img = new Image();
        img.src = props.editImgSrc;
        img.crossOrigin = "Anonymous";
        img.onload = () => {

            //元画像サイズ設定
            let newWidth = img.width;
            let newHeight = img.height;
            let scaleFactor = 0
            //最大サイズを超える場合リサイズ
            if (newWidth > maxWidth) {
                scaleFactor = maxWidth / newWidth;
            }
            if (newHeight > maxHeight) {
                scaleFactor = maxHeight / newHeight;
            }
            if (scaleFactor > 0) {
                newWidth = Math.floor(newWidth * scaleFactor);
                newHeight = Math.floor(newHeight * scaleFactor);
            }
            // imageCanvas(画像表示キャンバス)
            if (!canvasRef.current) return
            const canvas: any = canvasRef.current;
            canvas.width = newWidth;
            canvas.height = newHeight;
            setImageSize({
                width: newWidth,
                height: newHeight,
            })
            const context: CanvasRenderingContext2D = canvas.getContext("2d");
            context.drawImage(img, 0, 0, newWidth, newHeight);

            // lineCanvas(描画キャンバス)
            const lineCanvas: HTMLCanvasElement | null = lineCanvasRef.current;
            if (!lineCanvas) return;

            setLineCanvasContext(getContext(lineCanvas, 0, 0, newWidth, newHeight, null));

            // cropCanvas(トリミング範囲表示キャンバス)
            const cropCanvas: HTMLCanvasElement | null = cropCanvasRef.current;
            if (!cropCanvas) return;
            setCropCanvasContext(getContext(cropCanvas, 0, 0, newWidth, newHeight, null));

            // straightLinePointCanvas(直線描画表示キャンバス)
            const sLinePointCanvas: HTMLCanvasElement | null = straightLinePointCanvasRef.current;
            if (!sLinePointCanvas) return;
            setStraightLinePointCanvasContext(getContext(sLinePointCanvas, 0, 0, newWidth, newHeight, null));

            // mergeCanvas(マージキャンバス)
            const mergeCanvas: HTMLCanvasElement | null = mergeCanvasRef.current;
            if (!mergeCanvas) return;
            setMergeCanvasContext(getContext(mergeCanvas, 0, 0, newWidth, newHeight, img));

            // trimingCanvas(トリミング画像キャンバス)
            const trimingCanvas: HTMLCanvasElement | null = trimingCanvasRef.current;
            if (!trimingCanvas) return;
            setTrimingCanvasContext(getContext(trimingCanvas, 0, 0, newWidth, newHeight, img));

            if (!props.editImgSrc) return;
            setDrawing(false);
            setCanvasContext(context);
            dispatch(setPictureCropRect({ x: 0, y: 0, width: newWidth, height: newHeight }));
            dispatch(setPictureOriginCropRect({ x: 0, y: 0, width: newWidth, height: newHeight }));
            // 初期は直線描画
            dispatch(setPictureEditMode("lineMode"));
        }
    };


    const getContext = (canvas: any, x: number, y: number, widht: number, height: number, img: any) => {
        canvas.width = widht;
        canvas.height = height;
        const context: CanvasRenderingContext2D = canvas.getContext("2d");
        if (img) {
            context.drawImage(img, x, y, widht, height);
        }

        return context
    }

    const setEditMode = (mode: string) => {
        dispatch(setPictureEditMode(mode));
    }

    // モード切替
    React.useEffect(() => {
        switch (objPictureEdit.editMode) {
            case "handMode":
            case "lineMode":
                if (!lineCanvasContext || !straightLinePointCanvasContext) return;
                setDrawing(false)
                lineCanvasContext.globalCompositeOperation = "source-over"
                lineCanvasContext.lineWidth = defaultLineWidth;
                straightLinePointCanvasContext.lineWidth = defaultLineWidth;
                break;
            case "eraser":
                if (!lineCanvasContext || !straightLinePointCanvasContext) return;
                setDrawing(false)
                lineCanvasContext.globalCompositeOperation = "destination-out"
                lineCanvasContext.lineWidth = defaultEraserWidth;
                straightLinePointCanvasContext.lineWidth = defaultEraserWidth;
                break;
            case "crop":
                if (!cropCanvasContext) return;
                setDrawing(false)
                // 枠
                const z = hasCropErea(objPictureEdit.cropRect.width, objPictureEdit.cropRect.height, 18)
                let width = z * 4 * 10
                let height = z * 3 * 10
                dispatch(setPictureReload(!objPictureEdit.reload));
                drawCropArea(objPictureEdit.cropRect.x, objPictureEdit.cropRect.y, width, height)
                break;
            case "small_sej":
            case "medium_sej":
            case "large_sej":
                if (!lineCanvasContext || !straightLinePointCanvasContext) return;
                lineCanvasContext.globalCompositeOperation = "source-over"
                lineCanvasContext.lineWidth = defaultLineWidth;
                straightLinePointCanvasContext.lineWidth = defaultLineWidth;
                setTextValue("7")
                break;
            case "small_SP":
            case "medium_SP":
            case "large_SP":
                if (!lineCanvasContext || !straightLinePointCanvasContext) return;
                lineCanvasContext.globalCompositeOperation = "source-over"
                lineCanvasContext.lineWidth = defaultLineWidth;
                straightLinePointCanvasContext.lineWidth = defaultLineWidth;
                setTextValue("SP")
                break;
        }
    }, [objPictureEdit.editMode])

    /**
     * 画像に収まる4:3の最大値を求める
     */
    function hasCropErea(x: number, y: number, z: number): number {
        if (
            (x > (z * 4 * 10)) && (y > (z * 3 * 10))
        ) {
            return z
        }
        z = z - 1
        return hasCropErea(x, y, z)
    }

    // ドラッグの始め
    const handleMouseDown = (e: React.MouseEvent<HTMLCanvasElement>) => {
        const { offsetX, offsetY } = e.nativeEvent;
        switch (objPictureEdit.editMode) {
            case "lineMode":
                if (touchStart === TOUCHRESET) {
                    setStartToutchPoint({ x: offsetX, y: offsetY })
                    setTouchStart(TOUCHSTART)
                } else if (touchStart === TOUCHSTART) {
                    setTouchStart(TOUCHEND)
                }
                setDrawing(true);
                break;
            case "handMode":
            case "crop":
            case "eraser":
                startOperation(offsetX, offsetY);
                setDrawing(true);
                break;
        }
    };

    // ドラッグの終わり
    const handleMouseUp = (e: React.MouseEvent<HTMLCanvasElement>) => {
        switch (objPictureEdit.editMode) {
            case "lineMode":
                moveOperation(e.nativeEvent.offsetX, e.nativeEvent.offsetY)
                endOperation();
                break;
            case "handMode":
            case "crop":
            case "eraser":
                endOperation();
                break;
            case "small_sej":
            case "medium_sej":
            case "large_sej":
            case "small_SP":
            case "medium_SP":
            case "large_SP":
                drawText(e.nativeEvent.offsetX, e.nativeEvent.offsetY)
                break;
        }
    };


    // 操作開始時(マウスクリック、タッチ)
    const startOperation = (offsetX: number, offsetY: number): void => {
        setStartToutchPoint({ x: offsetX, y: offsetY })
        setDrawing(true);
    };

    //操作終了時（マウスクリック、タッチ）
    const endOperation = (): void => {
        setDrawing(false);
        dispatch(setPictureReload(!objPictureEdit.reload));
    };

    React.useEffect(() => {
        imgMerge(mergeCanvasContext)
    }, [objPictureEdit.reload])

    // ドラッグ中。線を引く、クラップ範囲の指定等を行う。
    const handleMouseMove = (e: React.MouseEvent<HTMLCanvasElement>) => {
        if (!drawing) return;
        switch (objPictureEdit.editMode) {
            case "handMode":
            case "crop":
            case "eraser":
                moveOperation(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
                break;
        }
    };

    const moveOperation = (offsetX: number, offsetY: number): void => {
        if (!canvasContext) return;
        // キャンバスの左上端の座標を取得
        const canvas: HTMLCanvasElement = canvasContext.canvas;
        const currentPoint = {
            x: offsetX,
            y: offsetY,
        };
        switch (objPictureEdit.editMode) {
            case "crop":
                if (!cropCanvasRef) return;
                if (!cropCanvasContext) return;
                let cropRectX = objPictureEdit.cropRect.x
                let cropRectY = objPictureEdit.cropRect.y
                let cropRectWidth = objPictureEdit.cropRect.width
                let cropRectHeight = objPictureEdit.cropRect.height
                if (startToutchPoint.x === offsetX) {
                    if (startToutchPoint.y > offsetY) {
                        // 上
                        cropRectY = cropRectY -= 1
                    } else if (startToutchPoint.y < offsetY) {
                        // 下
                        cropRectY = cropRectY += 1
                    }
                } else if (startToutchPoint.y === offsetY) {
                    if (startToutchPoint.x > offsetX) {
                        // 左横
                        cropRectX = cropRectX -= 1
                    } else if (startToutchPoint.x < offsetX) {
                        // 右横
                        cropRectX = cropRectX += 1
                    }
                } else {
                    if (startToutchPoint.x > offsetX && startToutchPoint.y > offsetY) {
                        // 左上
                        cropRectX = cropRectX -= 1
                        cropRectY = cropRectY -= 1
                    } else if (startToutchPoint.x > offsetX && startToutchPoint.y < offsetY) {
                        // 左下
                        cropRectX = cropRectX -= 1
                        cropRectY = cropRectY += 1
                    } else if (startToutchPoint.x < offsetX && startToutchPoint.y > offsetY) {
                        // 右上
                        cropRectX = cropRectX += 1
                        cropRectY = cropRectY -= 1
                    } else if (startToutchPoint.x < offsetX && startToutchPoint.y < offsetY) {
                        // 右下
                        cropRectX = cropRectX += 1
                        cropRectY = cropRectY += 1
                    }
                }
                // 座標補正
                if (cropRectX < 0) {
                    cropRectX = 0;
                }
                if (cropRectY < 0) {
                    cropRectY = 0;
                }
                if (canvas.width < (cropRectX + cropRectWidth)) {
                    cropRectX -= 1
                }
                if (canvas.height < (cropRectY + cropRectHeight)) {
                    cropRectY -= 1
                }

                drawCropArea(cropRectX, cropRectY, cropRectWidth, cropRectHeight)
                break;
            case "lineMode":
                if (touchStart === TOUCHSTART) {
                    if (!straightLinePointCanvasContext) return;
                    // ポイント描画
                    straightLinePointCanvasContext.beginPath();
                    straightLinePointCanvasContext.fillStyle = 'red';
                    let lineWidthValue = defaultLineWidth
                    straightLinePointCanvasContext.fillRect(
                        startToutchPoint.x - (lineWidthValue / 2),
                        startToutchPoint.y - (lineWidthValue / 2),
                        lineWidthValue,
                        lineWidthValue
                    );
                } else if (touchStart === TOUCHEND) {
                    if (!straightLinePointCanvasContext) return;
                    if (!lineCanvasContext) return;
                    if (straightLinePointCanvasContext) {
                        // ポイント削除
                        straightLinePointCanvasContext.clearRect(
                            0,
                            0,
                            straightLinePointCanvasContext.canvas.clientWidth,
                            straightLinePointCanvasContext.canvas.clientHeight
                        );
                    }
                    lineCanvasContext.beginPath();
                    lineCanvasContext.strokeStyle = 'red'
                    lineCanvasContext.fillStyle = 'red'
                    lineCanvasContext.lineWidth = defaultLineWidth;
                    lineCanvasContext.moveTo(startToutchPoint.x, startToutchPoint.y);
                    lineCanvasContext.lineTo(offsetX, offsetY);
                    lineCanvasContext.stroke();

                    setDrawing(false);
                    // 始点クリック位置の初期化
                    setStartToutchPoint({ x: 0, y: 0 })
                    setTouchStart(TOUCHRESET)
                }
                break;
            case "handMode":
            case "eraser":
                if (!canvasContext || !lineCanvasContext) return;
                // 座標補正
                if (offsetX < 0) {
                    offsetX = 0;
                } else if (canvas.width < offsetX) {
                    offsetX = canvas.width;
                }
                if (offsetY < 0) {
                    offsetY = 0;
                } else if (canvas.height < offsetY) {
                    offsetY = canvas.height;
                }
                if (objPictureEdit.editMode === 'handMode') {
                    lineCanvasContext.strokeStyle = 'red'
                    lineCanvasContext.fillStyle = 'red'
                }
                lineCanvasContext.beginPath();
                lineCanvasContext.moveTo(startToutchPoint.x, startToutchPoint.y);
                lineCanvasContext.lineTo(currentPoint.x, currentPoint.y);
                lineCanvasContext.stroke();

                setStartToutchPoint(currentPoint)
                break;
        }
    }

    /**
     * マージ処理
     * @param mergeCanvasContext
     */
    const imgMerge = async (mergeCanvasContext: any) => {
        if (mergeCanvasContext) {
            (async () => {
                await createImage(canvasRef.current).then((img) => {
                    mergeCanvasContext.drawImage(img, 0, 0)
                })
                await createImage(lineCanvasRef.current).then((img) => {
                    mergeCanvasContext.drawImage(img, 0, 0)
                })
                await createImage(straightLinePointCanvasRef.current).then((img) => {
                    mergeCanvasContext.drawImage(img, 0, 0)
                })
                // トリミング
                trimming()
            })();
        }
    }

    const createImage = (canvas: any) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = (e) => reject(e);
            image.src = canvas.toDataURL();
        });
    }

    const trimming = async () => {
        if (trimingCanvasContext) {
            const image: HTMLImageElement = await trimmingImage(mergeCanvasRef.current)
            const canvas: any = trimingCanvasRef.current;
            if (!canvas) return;
            canvas.width = objPictureEdit.cropRect.width
            canvas.height = objPictureEdit.cropRect.height
            trimingCanvasContext.drawImage(
                image,
                objPictureEdit.cropRect.x, objPictureEdit.cropRect.y,
                objPictureEdit.cropRect.width, objPictureEdit.cropRect.height,
                0, 0,
                objPictureEdit.cropRect.width, objPictureEdit.cropRect.height
            );
        }
    }

    const trimmingImage = async (canvas: any) => {
        const image: HTMLImageElement = await new Promise((resolve, reject) => {
            const image = new Image()
            image.addEventListener('load', () => resolve(image))
            image.addEventListener('error', reject)
            image.src = canvas.toDataURL()
        })
        return image
    }
    /**
     * マージ処理ここまで
     */


    // トリミングエリア調整
    const handleCrop = (d: string) => {
        if (!cropCanvasContext) return;
        if (objPictureEdit.editMode !== "crop") return;
        let x = objPictureEdit.cropRect.x
        let y = objPictureEdit.cropRect.y
        let newWidth = objPictureEdit.cropRect.width
        let newHeight = objPictureEdit.cropRect.height
        let newWidthOrigin = newWidth
        let newHeightOrigin = newHeight
        switch (d) {
            case "rigthBottom-subtraction":
                newWidth -= CROP_WIDTH
                newHeight -= CROP_HIEGHT
                break;
            case "rigthBottom-addition":
                newWidth += CROP_WIDTH
                newHeight += CROP_HIEGHT
                break;
        }

        if (x < 0) {
            x = 0
        }
        if (y < 0) {
            y = 0
        }
        if (imageSize.width < (x + newWidth)) {
            newWidth = newWidthOrigin
            newHeight = newHeightOrigin
        }
        if (imageSize.height < (y + newHeight)) {
            newWidth = newWidthOrigin
            newHeight = newHeightOrigin
        }
        drawCropArea(x, y, newWidth, newHeight)
        dispatch(setPictureReload(!objPictureEdit.reload));
    }

    // トリミング範囲描画
    const drawCropArea = (newX: number, newY: number, newWidth: number, newHeight: number) => {
        if (!cropCanvasContext) return
        // 画面クリア
        cropCanvasContext.clearRect(
            0,
            0,
            cropCanvasContext.canvas.width,
            cropCanvasContext.canvas.height
        );
        cropCanvasContext.beginPath()
        // 枠描画
        cropCanvasContext.rect(newX, newY, newWidth, newHeight);
        cropCanvasContext.strokeStyle = 'red';
        cropCanvasContext.lineWidth = 2;
        cropCanvasContext.stroke();
        dispatch(setPictureCropRect({ x: newX, y: newY, width: newWidth, height: newHeight }));
    }

    /**
     * 7、SP描画
     * @param offsetX 
     * @param offsetY 
     */
    const drawText = (offsetX: number, offsetY: number) => {
        if (!lineCanvasContext) return

        // 座標ずらし
        let x = offsetX - 15
        let y = offsetY + 25
        if (['small_SP', 'medium_SP', 'large_SP'].includes(textValue)) {
            x = offsetX - 25
            y = offsetY + 25
        }
        lineCanvasContext.globalAlpha = defaultTransParency;

        switch (objPictureEdit.editMode) {
            case "small_sej":
            case "small_SP":
                lineCanvasContext.font = '18px Roboto medium';
                break;
            case "medium_sej":
            case "medium_SP":
                lineCanvasContext.font = '26px Roboto medium';
                break;
            case "large_sej":
            case "large_SP":
                lineCanvasContext.font = '35px Roboto medium';
                break;
        }
        lineCanvasContext.strokeStyle = 'red';
        lineCanvasContext.fillStyle = 'red';
        lineCanvasContext.fillText(textValue, x, y)
        let lineX = offsetX - 26
        let lineXX = 36
        let lineY = offsetY - 6
        let lineYY = 42
        switch (objPictureEdit.editMode) {
            case "small_sej":
                lineX = offsetX - 24
                lineXX = 28
                lineY = offsetY
                lineYY = 34
                break;
            case 'small_SP':
                lineX = offsetX - 24
                lineXX = 38
                lineY = offsetY
                lineYY = 34
                break;
            case 'medium_SP':
                lineX = offsetX - 26
                lineXX = 52
                lineY = offsetY - 4
                lineYY = 38
                break;
            case "large_sej":
                lineX = offsetX - 30
                lineXX = 52
                lineY = offsetY - 20
                lineYY = 62
                break;
            case 'large_SP':
                lineX = offsetX - 24
                lineXX = 64
                lineY = offsetY - 18
                lineYY = 60
                break;
        }
        // 枠
        lineCanvasContext.rect(lineX, lineY, lineXX, lineYY);
        lineCanvasContext.lineWidth = 2;
        lineCanvasContext.stroke();
        dispatch(setPictureReload(!objPictureEdit.reload));
    }

    //元の画像状態に戻す
    const replyAll = () => {
        if (!canvasContext || !lineCanvasContext || !straightLinePointCanvasContext || !mergeCanvasContext || !cropCanvasContext) return;
        lineCanvasContext.clearRect(
            0,
            0,
            lineCanvasContext.canvas.clientWidth,
            lineCanvasContext.canvas.clientHeight
        );
        lineCanvasContext.beginPath()
        straightLinePointCanvasContext.clearRect(
            0,
            0,
            straightLinePointCanvasContext.canvas.clientWidth,
            straightLinePointCanvasContext.canvas.clientHeight
        );
        straightLinePointCanvasContext.beginPath()
        mergeCanvasContext.clearRect(
            0,
            0,
            mergeCanvasContext.canvas.clientWidth,
            mergeCanvasContext.canvas.clientHeight
        );
        mergeCanvasContext.beginPath()
        cropCanvasContext.clearRect(
            0,
            0,
            cropCanvasContext.canvas.width,
            cropCanvasContext.canvas.height
        );
        cropCanvasContext.beginPath()
        dispatch(setPictureCropRect({
            x: objPictureEdit.originCropRect.x,
            y: objPictureEdit.originCropRect.y,
            width: objPictureEdit.originCropRect.width,
            height: objPictureEdit.originCropRect.height
        }));


        dispatch(setPictureReload(!objPictureEdit.reload));
        dispatch(setPictureEditMode("lineMode"));
    };

    /**
     * アップロード関連
     */
    const confirmUpload = () => {
        setConfirmDialogOpen(true)
    }


    // 保存キャンセル
    const cancelUpload = () => {
        setConfirmDialogOpen(false)
    }

    /**
     * Canvasをblobとして取得
     *
     * @param {string} id  対象canvasのid
     * @return {object}
     */
    function getImagefromCanvas(canvas: any) {
        return new Promise((resolve) => {
            canvas.toBlob(function (blob: any) {
                resolve(blob)
            });
        });
    }

    // 登録
    const uploadResult = async () => {
        setConfirmDialogOpen(false)
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }

        imgMerge(mergeCanvasContext)
            .then(() => {
                getImagefromCanvas(trimingCanvasRef.current)
                    .then((image) => {
                        uploadImage(image)
                    })
            }).catch((e) => {
                console.log(e)
                dispatch(setPictureEditMode("lineMode"));
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }).finally(() => {
                dispatch(setPictureEditMode("lineMode"));
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
    }


    // 画像アップロード関数
    const uploadImage = async (image: any) => {
        const date = new Date();
        const dateString = date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, "0") + date.getDate().toString().padStart(2, "0") + '_' +
            date.getHours().toString().padStart(2, "0") + date.getMinutes().toString().padStart(2, "0") + date.getSeconds().toString().padStart(2, "0");

        // metaデータのファイル名を分割
        const fileData = props.editImgMeta.contentType.split(/[/\n]/);
        const path = '/' + objLongPageParam.planAreaId + '/' + objLongPageParam.branch + '/photo/EDITIMG_' + props.openId + '_' + dateString + '.' + fileData[1]
        const storageRef = ref(storage, path);

        const metadata = {
            contentType: props.editImgMeta.contentType,
            customMetadata: {
                GPSDateTimeStamp: props.editImgMeta.customMetadata === undefined
                    ? undefined
                    : props.editImgMeta.customMetadata.GPSDateTimeStamp
            }
        };
        await uploadBytes(storageRef, image, metadata)
            .then((snapshot) => {
                console.log("アップロードに成功しました");
                setOpen(false)
                props.handleModal(false)
                props.changeEditPhoto(props.openId, path)
            })
            .catch((error) => {
                console.log("アップロードに失敗しました");
            });
    }

    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <Box sx={{ margin: '2px 0 0 10px' }}>
                    <InputLabel>{titleValue}</InputLabel>
                </Box>
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        {/**  編集ボタンエリア */}
                        <Box sx={{ padding: '20px' }}>
                            <InputLabel>トリミング</InputLabel>
                            <Box sx={{ display: "flex" }}>
                                <Box>
                                    <Button
                                        sx={objPictureEdit.editMode === "crop" ? selectedList : nonSelectedList}
                                        onClick={() => { setEditMode('crop') }}><CropIcon /></Button>
                                </Box>
                                <Box sx={{ display: objPictureEdit.editMode === 'crop' ? 'flex' : 'none' }}>
                                    <Button
                                        variant="outlined" color="error" size="small"
                                        onClick={() => { handleCrop("rigthBottom-subtraction") }}>-</Button>
                                    <Button
                                        variant="contained" color="success" size="small"
                                        onClick={() => { handleCrop("rigthBottom-addition") }}>+</Button>
                                </Box>
                            </Box>
                            <InputLabel>手書き</InputLabel>
                            <Box>
                                <Button
                                    sx={objPictureEdit.editMode === "handMode" ? selectedList : nonSelectedList}
                                    onClick={() => { setEditMode('handMode') }}><BorderColorIcon /></Button>
                            </Box>
                            <InputLabel>直線</InputLabel>
                            <Box>
                                <Button
                                    sx={objPictureEdit.editMode === "lineMode" ? selectedList : nonSelectedList}
                                    onClick={() => { setEditMode('lineMode') }}><BlurOffIcon /></Button>
                            </Box>
                            <InputLabel>消しゴム</InputLabel>
                            <Box>
                                <Button
                                    sx={objPictureEdit.editMode === "eraser" ? selectedList : nonSelectedList}
                                    onClick={() => { setEditMode('eraser') }}><AutoFixHighIcon /></Button>
                            </Box>
                            <InputLabel>7</InputLabel>
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={objPictureEdit.editMode === "small_sej" ? selectedList : nonSelectedList}>
                                    <Button
                                        sx={{ color: '#FF0000', fontWeight: 'bold', fontSize: '1.2em' }}
                                        onClick={() => { setEditMode("small_sej") }}>小</Button>
                                </Box>
                                <Box sx={objPictureEdit.editMode === "medium_sej" ? selectedList : nonSelectedList}>
                                    <Button
                                        sx={{ color: '#FF0000', fontWeight: 'bold', fontSize: '1.2em' }}
                                        onClick={() => { setEditMode("medium_sej") }}>中</Button>
                                </Box>
                                <Box sx={objPictureEdit.editMode === "large_sej" ? selectedList : nonSelectedList}>
                                    <Button
                                        sx={{ color: '#FF0000', fontWeight: 'bold', fontSize: '1.2em' }}
                                        onClick={() => { setEditMode("large_sej") }}>大</Button>
                                </Box>
                            </Box>
                            <InputLabel sx={{ color: '#F00', fontSize: '0.75rem' }}>※写真に合わせたサイズを選択してください</InputLabel>
                            <InputLabel>SP</InputLabel>
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={objPictureEdit.editMode === "small_SP" ? selectedList : nonSelectedList}>
                                    <Button
                                        sx={{ color: '#FF0000', fontWeight: 'bold', fontSize: '1.2em' }}
                                        onClick={() => { setEditMode("small_SP") }}>小</Button>
                                </Box>
                                <Box sx={objPictureEdit.editMode === "medium_SP" ? selectedList : nonSelectedList}>
                                    <Button
                                        sx={{ color: '#FF0000', fontWeight: 'bold', fontSize: '1.2em' }}
                                        onClick={() => { setEditMode("medium_SP") }}>中</Button>
                                </Box>
                                <Box sx={objPictureEdit.editMode === "large_SP" ? selectedList : nonSelectedList}>
                                    <Button
                                        sx={{ color: '#FF0000', fontWeight: 'bold', fontSize: '1.2em' }}
                                        onClick={() => { setEditMode("large_SP") }}>大</Button>
                                </Box>
                            </Box>
                            <InputLabel sx={{ color: '#F00', fontSize: '0.75rem' }}>※写真に合わせたサイズを選択してください</InputLabel>
                            <InputLabel>リセット</InputLabel>
                            <Box>
                                <Button onClick={() => { replyAll(); }}><RefreshIcon /></Button>
                            </Box>
                            <Box sx={{
                                bottom: 0,
                                position: 'absolute',
                                display: 'flex',
                            }}>
                                <Box sx={{ margin: "10px", alignItems: "center" }}>
                                    <Button variant="outlined" color="error" size="small" onClick={() => { closeEditForm() }}>{LOCAL_CONSTANT.LABEL.CANCEL}</Button>
                                </Box>
                                <Box sx={{ margin: "10px", alignItems: "center" }}>
                                    <Button variant="contained" color="success" size="small" onClick={() => { confirmUpload() }}>{LOCAL_CONSTANT.LABEL.SAVE}</Button>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{
                            height: Math.floor(window.screen.height * 0.75)
                        }}>
                            {/** キャンバス */}
                            <Box sx={{
                                height: "100%",
                                width: '900px',
                                display: 'flex',
                                justifyContent: 'center', /*左右中央揃え*/
                                alignItems: 'center',     /*上下中央揃え*/
                            }}>
                                {/** 画像キャンバス */}
                                <canvas
                                    ref={canvasRef}
                                    id="imageCanvas"
                                    style={{ position: "absolute", zIndex: 1, border: '1px solid black' }}
                                />
                                <canvas
                                    ref={lineCanvasRef}
                                    id="lineCanvas"
                                    style={{ position: "absolute", zIndex: 2 }}
                                />
                                <canvas
                                    ref={cropCanvasRef}
                                    id="cropCanvas"
                                    onMouseDown={handleMouseDown}
                                    onMouseMove={handleMouseMove}
                                    onMouseUp={handleMouseUp}
                                    style={{ position: "absolute", zIndex: 3 }}
                                />
                                <canvas
                                    ref={straightLinePointCanvasRef}
                                    id="straightLinePointCanvas"
                                    style={{ position: "absolute", zIndex: 2 }}
                                />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'none' }}>
                            {/**  マージキャンバス */}
                            <Box sx={{ width: imageSize.width, height: imageSize.height }}>
                                <canvas
                                    ref={mergeCanvasRef}
                                    style={{ position: "absolute", zIndex: 1 }}
                                />
                            </Box>
                            {/**  トリミングキャンバス */}
                            <Box sx={{ width: imageSize.width, height: imageSize.height }}>
                                <canvas
                                    ref={trimingCanvasRef}
                                    style={{ position: "absolute", zIndex: 1 }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <ConfirmDialog props={{
                    open: confirmDialogOpen,
                    handleModal: setConfirmDialogOpen,
                    onCancel: cancelUpload,
                    onExecution: uploadResult,
                    mode: "uploadConfirm",
                    body: LOCAL_CONSTANT.CONFIRM_MESSAGE.CHANGE_SAVE,
                    confirmCancel: LOCAL_CONSTANT.LABEL.CANCEL,
                    confirmOk: LOCAL_CONSTANT.LABEL.SAVE
                }}
                />
            </Box>
        </Modal>
    );
};

export default PhotoEdit;